import { Item } from '@lendi-ui/dropdown';

import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { ApplicantEntityIndex } from '@funnels/types';
import { HelpTooltip } from '@funnels/ui-components';

import { DropdownField } from '../../Fields/';

interface GuarantorForProps extends ApplicantEntityIndex {
  borrowerApplicantOptions: Item[];
}

export const GuarantorFor = (props: GuarantorForProps) => {
  const { applicantIndex, borrowerApplicantOptions, ...rest } = props;

  return (
    <DropdownField
      {...rest}
      label="Guarantor for"
      name={FIELD_PATHS.APPLICANT_GUARANTOR_RELATIONSHIP_TO_BORROWER_APPLICANT_ID(applicantIndex)}
      options={borrowerApplicantOptions}
      className={PII_FIELD_MASKING_CLASS}
      labelAfter={
        <HelpTooltip
          content={
            'If the guarantor is related to more than one borrower, select the borrower with the most direct relationship.'
          }
          position="top"
        />
      }
    />
  );
};
